export default __webpack_public_path__ + "static/media/homepage-coach-bottom.7e50fd15.jpg";